import React from "react";
import "./CreditRating.scss";
import creditInfoImg from "../../../assets/Reports/Credit Rating 2025.png";

const CreditRating = () => {
  return (
    <>
      <div className="credit_rating">
        <div className="container">
          <div className="heading_box">Credit Rating</div>
          <div className="my-5 mx-auto img_container text-center">
            <img src={creditInfoImg} className="img-fluid" alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default CreditRating;
